import { SectionTitle } from "../../components/common/SectionTitle";

type MapViewProps = {
  title: string;
  region: string;
  image: string;
  imageAlt: string;
  locations: readonly Location[];
};

type Location = {
  name: string;
  url: string;
};

export function MapView({
  title,
  region,
  image,
  imageAlt,
  locations,
}: MapViewProps) {
  return (
    <section id="mapa" className="section map">
      <SectionTitle title={title} />
      <div className="map-grid">
        <div className="map-media">
          <img
            src={image}
            alt={imageAlt}
            className="map-image"
            loading="lazy"
            decoding="async"
            width={649}
            height={665}
            sizes="(max-width: 640px) 92vw, (max-width: 1200px) 56vw, (max-width: 1800px) 46vw, 820px"
          />
        </div>
        <div className="map-info">
          <h3>{region}</h3>
          <ul>
            {locations.map((location, index) => (
              <li key={index}>
                <a href={location.url} target="_blank" rel="noopener noreferrer">
                  {location.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
